// Shared footprint-size reader. Geometry and movement must not import the cast gate for this leaf.
type Row = Record<string, unknown>;

export interface CombatSizeReaders {
  value: (row: Row | null, key: string) => unknown;
  inventoryField?: (row: Row | null, key: string) => unknown;
}

/** SizeType base_size (get_size_dimensions width); an unknown id reads Medium. */
export const SIZE_WIDTH_FT: Readonly<Record<string, number>> = { '13456FEC-A2EE-DB46-5829-0EB2F627E1B7': 2.5, 'AAC1F466-7A8B-C593-1ADC-FC402B8909D7': 3.75,
  'DC23AA88-CB3D-EA4E-F6F7-6389ABC4F9DC': 5, '52FFDB16-A991-C8D4-FE59-7C75EE6CF7AD': 10, 'D0EF6D7A-82BC-1E6E-9D36-5004C7E0561C': 15,
  'CEA2946E-D395-46EA-A6E7-74D21EA2376E': 20, 'C94CDD74-8ACD-26B0-5C53-4CA29CF21D68': 25, '4C33FD22-5382-15DA-1C46-F57F14378AFD': 30 };
const UUID = /^[0-9A-F]{8}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{12}$/i;
const record = (value: unknown): Row | null => value !== null && typeof value === 'object' && !Array.isArray(value) ? value as Row : null;

/** The footprint width from inventory_size, the size layer, or the EC size; null = sizeless. */
export function combatSizeFt(row: Row, read: CombatSizeReaders): number | null {
  const override = read.inventoryField ? read.inventoryField(row, 'inventory_size') : null;
  let sizeId = typeof override === 'string' && UUID.test(override) ? override : read.value(row, 'size');
  if (sizeId === null || sizeId === undefined || sizeId === '') sizeId = read.value(record(row.encounter_creatures), 'size');
  if (sizeId === null || sizeId === undefined || sizeId === '') return null;
  const width = SIZE_WIDTH_FT[String(sizeId ?? '').trim().toUpperCase()] ?? 5;
  return width > 0 ? width : null;
}
